import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { EventDTO } from './event.dto';

export class EventResponseModel extends GlobalResponseObject {
  data?: any;
  response:EventDTO[];
}

export class AllEventsResponseModel extends GlobalResponseObject{
  data?: EventDTO[];
}

export class SingleEventResponseModel extends GlobalResponseObject {
  data?:any;
  response?:any;
}